import { Effect } from "../Materials/effect";
var name = 'postprocessVertexShader';
var shader = "\nattribute vec2 position;\nuniform vec2 scale;\n\nvarying vec2 vUV;\nconst vec2 madd=vec2(0.5,0.5);\nvoid main(void) {\nvUV=(position*madd+madd)*scale;\ngl_Position=vec4(position,0.0,1.0);\n}";
Effect.ShadersStore[name] = shader;
/** @hidden */
export var postprocessVertexShader = { name: name, shader: shader };
//# sourceMappingURL=postprocess.vertex.js.map